import axios, { CancelTokenSource } from 'axios';
import { apiErrorInterceptor } from './apiErrorInterceptor';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_API,
  withCredentials: true,
});

api.interceptors.request.use(
  config => {
    if (config.headers) {
      config.headers.App = 'waiter';
    }

    return config;
  },
  err => Promise.reject(err)
);

api.interceptors.response.use(
  response => response,
  error => apiErrorInterceptor(error)
);

export function getCancelTokenSource(): CancelTokenSource {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  return source;
}

export { api };
